import React, {useContext} from 'react'
import {useDroppable} from "@dnd-kit/core"
import {SortableContext, verticalListSortingStrategy} from "@dnd-kit/sortable"
import {FormBuilderContext} from "../context/form-builder-context.jsx";
import FormBuilderComponentsType from "./form-builder-components-type.jsx";
import {Card} from "../../../../../components/card/card.jsx";

const FormBuilderCards = ({structure}) => {
    const {setNodeRef} = useDroppable({id: "droppable"})
    const {handleSelectItem} = useContext(FormBuilderContext)

    const onClick = (e) => {
        if (e.target.classList.contains("card-body")) handleSelectItem(null)
    }

    return (
        <div className={"col-span-7"} ref={setNodeRef}>
            <Card>
                <Card.Body className={"card-body select-none overflow-auto h-[calc(100vh-135px)]"} onClick={onClick}>
                    <SortableContext items={structure} strategy={verticalListSortingStrategy}>
                        {structure.map((item) => <FormBuilderComponentsType item={item} key={item.id}/>)}
                    </SortableContext>
                </Card.Body>
            </Card>
        </div>
    )
}

export default FormBuilderCards